import React from 'react'
import ReactGA from 'react-ga'
import Banner from '../Banner'

function initializeGA(){
    ReactGA.initialize('UA-144557614-1');
    ReactGA.pageview('/about')
}

export default class About extends React.Component {

	componentDidMount(){
		initializeGA();
	}
    
    render(){

        return(
            <div>
                <Banner 
            backgroundImage="url(assets/img/bg-apt.jpg)"
            title="Criando ótimas oportunidades para você"
            subTitle="Conheça melhor o seu corretor imobiliário!"/>

            <div className="container">
            <div className="row">
					<div className="col-md-5 animate-box">
						<div className="owl-carousel3">
							<div className="item" style={{marginTop: "24px"}}>
								<img className="img-responsive about-img" src="assets/img/bio_photo.png" alt="Paulo Ymamura" />
							</div>
						</div>
					</div>
					<div className="col-md-6 col-md-push-1 animate-box">
						<div className="about-desc">
							<div>
								<div className="item" style={{marginTop: "24px"}}>
									<h2><span>Paulo</span><span> Ymamura</span></h2>
                                    <p>Corretor Imobiliário</p>
								</div>
								
							</div>
							<div className="desc">
								<p>Com mais de 22 anos de experiência no ramo imobiliário, Paulo trabalha duro e tem o compromisso de viabilizar o seu sonho de um apartamento próprio ou investimento, atuando principalmente em Osasco, Barueri e Região Oeste da cidade de São Paulo, sempre busca trazer o melhor em termos de custo-benefício e facilidades para seus clientes.</p>
								<p><i className="fas fa-mobile"></i><a href="tel: +55 11 99152-1740"> Fone: (11) 99152-1740</a></p>
                                <p><i className="fas fa-envelope-square"></i><a href={"mailto:paulo_ymamura@hotmail.com?Subject=Contato%20via%20website%20"}> Email: paulo_ymamura@hotmail.com</a></p>

							</div>
						</div>
					</div>
				</div>
                </div>           


            </div>
        );
    };

   
}


// WEBPACK FOOTER //
// ./src/common/About/index.jsx